import { Box, Stack } from '@mui/material'
import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { BackButton } from '~/src/components/atoms/Button/BackButton/BackButton'
import { ProtectedPage } from '~/src/components/templates'
import { ContactOrderCreateForm, MessageList } from '~/src/components/organisms'
import { useMessage } from '~/src/hooks'
import { orderRepository } from '~/src/repositories'

export const ContactOrderCreate: React.VFC = (): JSX.Element => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const [isLoading, setLoading] = useState(false)
  const { handleOpenWithErrorMessage, handleOpenWithSuccessMessage } = useMessage()

  /**
   * onSubmitNegotiationDetail
   * @param values
   */
  const onSubmitContactOrderCreate = async (values: {
    refNo: string
    partsCode: string
    manufacturer: string
    carName: string
    vehicleModel: string
    engineModel: string
    engineDetail: string
    drive1: string
    transmission: string
    drive2: string
    year: number
    orderDetail: string
    customerId: number
    supplyType: string
    orderDate: string
    arrivalDate: string
    supplier: string
    remark: string
    genuinePartNumber: string
    originalRemark: string
    withCatalyst: boolean
  }) => {
    setLoading(true)
    try {
      await orderRepository.postRequestOrder(values)
      handleOpenWithSuccessMessage('登録しました')
      navigate('/admin/order/contact-order/list', { replace: true })
    } catch (e: any) {
      console.error(e)
      handleOpenWithErrorMessage(e.message)
    } finally {
      setLoading(false)
    }
  }

  const data = {
    partsCode: null,
    manufacturer: null,
    drive1: '',
    transmission: '',
    drive2: '',
    withCatalyst: '',
    customerId: null,
    arrivalDate: null,
    orderDate: null,
    supplyType: '',
    status: ''
  };

  return (
    <ProtectedPage pageTitle={t('contact_order_create.title')}>
      <BackButton location={location} />
      <Stack mb={'275px'}>
        <ContactOrderCreateForm onSubmit={onSubmitContactOrderCreate} data={data} loading={isLoading} />
      </Stack>
    </ProtectedPage>
  )
}
